export default "__VITE_ASSET__Db4PzZcI__"